import React, { useState, useEffect, useRef } from 'react';
import './EnrolNow.css';
import './BookTrail.css';
import { areas } from '../Centers/areas';
import axios from "axios";
import Swal from 'sweetalert2';
import { trackEvent } from '../facebookPixel';
import { initFacebookPixel } from '../facebookPixel';
import { useNavigate } from "react-router-dom";

const BookTrial = () => {
  const [userName, setUserName] = useState('');
  const [selectedChildId, setSelectedChildId] = useState(null);
  const [showCreateChildInput, setShowCreateChildInput] = useState(false);
  const [newChildName, setNewChildName] = useState('');
  const [contactNumber, setContactNumber] = useState('');
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [otp, setOtp] = useState('');
  const [selectedArea, setSelectedArea] = useState('');
  const [showAreaDropdown, setShowAreaDropdown] = useState(false);
  const [selectedCenter, setSelectedCenter] = useState('');
  const [selectedStartTime, setSelectedStartTime] = useState('');
  const [selectedEndTime, setSelectedEndTime] = useState('');
  const [selectedTrialTime, setSelectedTrialTime] = useState('');
  const [trialTimes, setTrialTimes] = useState([]);
  const [showCenterDropdown, setShowCenterDropdown] = useState(false);
  const [showChildDropdown, setShowChildDropdown] = useState(false);
  const [selectedAge, setSelectedAge] = useState('5-8');

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [selectedBatchId, setSelectedBatchId] = useState(null);
  const [formData, setFormData] = useState(null);
  const dropdownRef = useRef(null);
  const selectWrapperRef = useRef(null);
  const childDropdownRef = useRef(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [centers, setCenters] = useState([]);
  const navigate = useNavigate();
  const [updatedAmount, setUpdatedAmount] = useState(null);
  const [discountedAmount, setdiscountedAmount] = useState(null);
  const [discountedShow, setdiscountedShow] = useState(false);
  const apiKey = process.env.REACT_APP_API_KEY; 
  useEffect(() => {
    return () => {
      sessionStorage.setItem('bookTrialScrollPosition', window.scrollY);
    };
  }, []);
  useEffect(() => {
    initFacebookPixel(); // Track page view when this page loads
  }, []);
  // Restore scroll position when the component mounts
  useEffect(() => {
    const savedScrollPosition = sessionStorage.getItem('bookTrialScrollPosition');
    if (savedScrollPosition) {
      window.scrollTo(0, parseInt(savedScrollPosition));
      sessionStorage.removeItem('bookTrialScrollPosition'); // Clear the saved position
    }
  }, []);
  const [errorMessages, setErrorMessages] = useState({
    userName: '',
    contactNumber: '',
    selectedArea: '',
    selectedCenter: '',
    selectedPlan: '',
    selectedTrialTime: '',
    selectedStartTime: '',
    selectedEndTime: '',

    otp: '',
    child: '',
    age: '',
  });
  const areaDropdownRef = useRef(null);
  const centerDropdownRef = useRef(null);
  const [userDetails, setUserDetails] = useState(null);
  const [parentId, setParentId] = useState(null);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [isNewUser, setIsNewUser] = useState(false);


  const formatDateToYYYYMMDD = (dateInput) => {
    const date = new Date(dateInput); // Ensures dateInput is converted to a Date object
    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  useEffect(() => {
    if (contactNumber) {
      setIsOtpVerified(false);
      setOtp('');
      setUserName('');
      setUserDetails(null);
      setShowOtpInput(false);
      setIsNewUser(false);
      setErrorMessages({
        userName: '',
        contactNumber: '',
        selectedArea: '',
        selectedCenter: '',
        selectedPlan: '',
        selectedTrialTime: '',
        selectedStartTime: '',
        selectedEndTime: '',
        otp: '',
        child: '',
        age: '',
      });

    }
  }, [contactNumber]);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (areaDropdownRef.current && !areaDropdownRef.current.contains(event.target)) {
        setShowAreaDropdown(false);
      }
      if (centerDropdownRef.current && !centerDropdownRef.current.contains(event.target)) {
        setShowCenterDropdown(false);
      }
      if (childDropdownRef.current && !childDropdownRef.current.contains(event.target)) {
        setShowChildDropdown(false);
        setShowCreateChildInput(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const fetchSportsCenters = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_API_URL_PURCHASE, {
        headers: {
          "x-api-key": apiKey
        }
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Failed to fetch sports centers.');
      }
      const defaultImages = [
        "https://imgmediagumlet.lbb.in/media/2022/01/61efa39514a08c2400a7ce56_1643094933277.png",
        "https://i.ytimg.com/vi/K8RGq4xtJbg/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLAnvqqpSN_Z3Gha4COeOk9un1cj8Q",
        "https://www.scai.in/wp-content/uploads/2023/06/DSC2954-scaled.jpg"
      ];
      setCenters(data.sportsToAcademiesMap.Swimming.map(center => {
        const academyId = center?.id;
        const sports = data.academiesToSportsMap[academyId] || [];
        return {
          id: academyId || [],
          name: center?.name || 'Unknown Center',
          sports: sports.map(sport => sport.sport_name) || [],
          latitude: center?.latitude || 0,
          longitude: center?.longitude || 0,
          images: (center?.images && center.images.length > 0) ? center.images : defaultImages,
        };
      }));

    } catch (error) {
      showBackendError(error);
    }
  };

  useEffect(() => {
    fetchSportsCenters();
  }, []);

  useEffect(() => {
  }, [selectedChildId]);

  const haversine = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  const handleAreaChange = (areaName) => {
    setSelectedArea(areaName);
    setSelectedCenter('');
    setSelectedPlan(null);
    setSelectedTrialTime('');
    setSelectedStartTime('');
    setSelectedEndTime('');
    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      selectedArea: '',
      selectedCenter: '',
      selectedPlan: '',
      selectedTrialTime: '',
      selectedStartTime: '',
      selectedEndTime: ''
    }));
    setShowAreaDropdown(false);
  };

  const handleCenterChange = (centerName) => {

    setSelectedCenter(centerName);
    setSelectedPlan(null);
    setSelectedTrialTime('');
    setSelectedStartTime('');
    setSelectedEndTime('');
    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      selectedCenter: '',
      selectedPlan: '',
      selectedTrialTime: '',
      selectedStartTime: '',
      selectedEndTime: ''
    }));
    setShowCenterDropdown(false);

    const selectedCenterData = centers.find(center => center.name === centerName);
    const selectedCenterId = selectedCenterData?.id;
    const availablePlans = plans.filter(plan => plan.centerId === selectedCenterId && plan.sportId === 11);
    setFilteredPlans(availablePlans);
  };

  const fetchUserDetails = async (mobileNumber) => {
    try {
      const formattedMobileNumber = mobileNumber.startsWith('+91') ? mobileNumber : '+91' + mobileNumber;

      const response = await fetch(process.env.REACT_APP_API_URL_FETCH_USER, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'x-api-key': apiKey, },
        body: JSON.stringify({ mobileNumber: formattedMobileNumber }),
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Failed to fetch user details.');
      }
      if (data && data.userDetails.success) {
        setUserDetails(data.userDetails);
        setIsNewUser(false);

        const parentId = data.userDetails.parent.id;
        setParentId(parentId);

        const firstChild = data.userDetails.children[0];
        const firstChildId = firstChild ? firstChild.id : null;
        setSelectedChildId(null);
      } else {
        setUserDetails(null);
        setIsNewUser(true);
        setParentId(null);
        setSelectedChildId(null);
      }
    } catch (error) {
      setIsNewUser(true);
      setParentId(null);
      setSelectedChildId(null);
    }
  };


  const handleOptionSelect = (id) => {
    setSelectedCenter(id);
    setShowCenterDropdown(false);
  };

  const handleChildSelect = (child) => {
    if (!child.id) {
      setUserName(child.name); // Set parent name
      setSelectedChildId(null);
    } else {
      setUserName(child.name); // Set child name
      setSelectedChildId(child.id);
    }
    setErrorMessages((prevErrors) => ({ ...prevErrors, child: '' })); // Clear child error
    setShowChildDropdown(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let errors = {
      userName: !userName.trim() ? 'Name is required' : '',
      contactNumber: !contactNumber.trim() || !isContactNumberValid ? 'Please enter a valid contact number' : '',
      selectedArea: !selectedArea ? 'Please select an area' : '',
      selectedCenter: !selectedCenter ? 'Please select a center' : '',
      selectedPlan: !selectedPlan ? 'Please select a plan' : '',
      selectedTrialTime: !selectedTrialTime ? 'Please select a Time Slot' : '',
      selectedStartTime: !selectedStartTime ? 'Please select a start time' : '',
      selectedEndTime: !selectedEndTime ? 'Please select an end time' : '',
      otp: !isOtpVerified ? 'Please verify OTP before submitting' : '',
      child: !userName.trim() ? 'Please select or create a child' : '',
      age: !selectedAge ? 'Please select an age range' : '',

    };

    const hasErrors = Object.values(errors).some((error) => error !== '');

    if (hasErrors) {
      setErrorMessages(errors);
      return;
    }

    try {
      // Ensure the contact number starts with +91
      let formattedContactNumber = contactNumber.trim();
      if (!formattedContactNumber.startsWith("+91")) {
        formattedContactNumber = "+91" + formattedContactNumber;
      }

      const amountResponse = await fetch(process.env.REACT_APP_API_URL_MOBILE_CHECKER, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key':apiKey,
        },
        body: JSON.stringify({
          mobile_number: formattedContactNumber,
          amount: selectedPlan.price,
        }),
      });


      const amountData = await amountResponse.json();
      if (amountResponse.ok) {
        setdiscountedAmount(amountData.discountedAmount);
        setUpdatedAmount(amountData.amount);
        if (amountData.isAlreadyMember === 1) {
          setdiscountedShow(true)
          // showToast("Hurray! You got a discount! 🎉");
        } else {
        }
      } else {
        setErrorMessages({ api: 'Failed to fetch the amount from server' });
        return;
      }

      const bookingData = {
        userName,
        contactNumber,
        selectedArea,
        selectedCenter,
        selectedPlan,
        selectedTrialTime,
        startDate,
        endDate,
        start_time: selectedStartTime,
        end_time: selectedEndTime,
        batch_id: selectedBatchId,
        age: selectedAge,
      };

      setFormData(bookingData);
      setShowConfirmationModal(true);
    } catch (error) {
      setErrorMessages({ api: 'Failed to process the booking' });
      showBackendError(error);
    }
  };
  const initiateRazorpayPayment = async (bookingDataForPurchase, bookingData, createOrder) => {
    try {
      const amountInPaise = Math.round(bookingDataForPurchase.amount * 100);
      const razorpayOrder = await axios.post(
        process.env.REACT_APP_API_URL_ORDER_ID,
        {
          amount: amountInPaise,
          currency: "INR",
          receipt: `receipt_${new Date().getTime()}`,
        },
        {
          headers: {
            "x-api-key": apiKey,
          },
        }
      );
      const enrollmentDataString = `sc,sw,Aid:${bookingDataForPurchase.academy_id},Pid:${bookingDataForPurchase.plan_id},ST:${bookingDataForPurchase.start_time},ET:${bookingDataForPurchase.end_time},N:${bookingDataForPurchase.name},MN:${bookingDataForPurchase.mobile_number}`;

      const razorpay = new window.Razorpay({
        key: "rzp_live_uh7h7N55m9BHaZ",
        amount: razorpayOrder.data.amount,
        currency: razorpayOrder.data.currency,
        order_id: razorpayOrder.data.id,
        name: "Summer Camp",
        description: enrollmentDataString,
        handler: async function (response) {
          if (response.razorpay_payment_id && response.razorpay_order_id && response.razorpay_signature) {
            try {
              await verifyPayment(response, bookingDataForPurchase, createOrder);
            } catch (err) {
              setError("Payment verification failed.");
              showBackendError(err);
              Swal.fire({
                title: 'Oops!',
                text: 'Payment verification failed.',
                icon: 'error',
                confirmButtonText: 'Try Again'
              });
            }
          } else {
            showBackendError({ message: 'Invalid payment response.' });
            setError("Invalid payment response.");
            Swal.fire({
              title: 'Oops!',
              text: 'Invalid payment response.',
              icon: 'error',
              confirmButtonText: 'Try Again'
            });
          }
        },
        modal: {
          ondismiss: function () {
            Swal.fire({
              title: 'Oops! Payment Failed',
              text: 'If amount is deducted from your account/card/wallet, please reach out to our customer support.',
              icon: 'error',
              showCancelButton: true,
              cancelButtonText: 'Contact Support',
              confirmButtonText: 'Try Again',
            }).then((result) => {
              if (result.dismiss === Swal.DismissReason.cancel) {
                // Open WhatsApp for customer support
                window.open('https://wa.me/+919663979929?text=Hello%20Machaxi', '_blank');  // Replace with your WhatsApp number
              }
            });
          }
        },
        prefill: {
          name: bookingDataForPurchase.name,
          contact: bookingDataForPurchase.mobile_number,
        },
        theme: {
          color: "#f5a623",
        },
      });

      razorpay.on('payment.failed', function (response) {
        Swal.fire({
          title: 'Oops!',
          text: 'Payment failed. Please try again.',
          icon: 'error',
          confirmButtonText: 'Try Again'
        });
      });

      razorpay.open();

    } catch (err) {
      showBackendError(err);
      setError("Something went wrong while creating Razorpay order.");
      Swal.fire({
        title: 'Oops!',
        text: 'Something went wrong while creating Razorpay order.',
        icon: 'error',
        confirmButtonText: 'Try Again'
      });
    }
  };

  const verifyPayment = async (response, bookingDataForPurchase, createOrder) => {
    try {
      if (!bookingDataForPurchase) {
        setError("Booking data is missing.");
        return;
      }

      const amountInPaise = Math.round(bookingDataForPurchase.amount * 100);

      const verificationResponse = await axios.post(
        process.env.REACT_APP_API_URL_VERIFY,
        {
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_order_id: response.razorpay_order_id,
          razorpay_signature: response.razorpay_signature,
          amount: amountInPaise,
          id: bookingDataForPurchase.id,
        },
        {
          headers: {
            "x-api-key":apiKey,
          },
        }
      );
      window.location.href = '/SuccessPage';
      sessionStorage.setItem('paymentStatus', 'success');
      sessionStorage.setItem('message', 'You are successfully enrolled for Summer Camp. We have shared invoice and enrollment details on your WhatsApp. If you havenot received it or have any other query, kindly contact our support team.');


    } catch (err) {
      setError("Something went wrong while verifying payment.");
      Swal.fire({
        title: 'Oops! Payment Failed',
        text: 'If amount is deducted from your account/card/wallet, please reach out to our customer support.',
        icon: 'error',
        showCancelButton: true,
        cancelButtonText: 'Contact Support',
        confirmButtonText: 'Try Again',
      }).then((result) => {
        if (result.dismiss === Swal.DismissReason.cancel) {
          // Open WhatsApp for customer support
          window.open('https://wa.me/+919663979929?text=Hello%20Machaxi', '_blank');  // Replace with your WhatsApp number
        }
      });
    }
  };

  function showToast(message) {
    const toastElement = document.createElement('div');
    toastElement.classList.add('toast');
    toastElement.innerHTML = message;
    document.body.appendChild(toastElement);

    setTimeout(() => {
      toastElement.classList.add('show');
    }, 300);

    setTimeout(() => {
      toastElement.classList.remove('show');
      setTimeout(() => {
        document.body.removeChild(toastElement);
      }, 500);
    }, 3000);
  }

  const handleOtpVerification = async () => {
    try {
      const formattedContactNumber = contactNumber.startsWith('+91') ? contactNumber : `+91${contactNumber}`;
      const response = await axios.post(process.env.REACT_APP_API_URL_OTP_VERIFY, {
        data: {
          phone_number: formattedContactNumber,
          has_firebase_check: false,
          otp: otp,
        },
      });

      if (response.data.success) {
        setIsOtpVerified(true);
      } else {
        setErrorMessages((prevErrors) => ({
          ...prevErrors,
          otp: response.data.message || 'Invalid OTP, please try again',
        }));
        Swal.fire({
          icon: 'error',
          title: 'Invalid OTP',
          text: response.data.message || 'The OTP you entered is invalid. Please try again.',
        });
      }
    } catch (error) {
      setErrorMessages((prevErrors) => ({
        ...prevErrors,
        otp: 'Failed to verify OTP. Please try again.',
      }));
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to verify OTP. Please try again.',
      });
    }
  };

  const handleInputChange = (e, field) => {
    const value = e.target.value;
    setErrorMessages((prevErrors) => ({ ...prevErrors, [field]: '' }));

    if (field === 'userName') {
      setUserName(value);
    } else if (field === 'contactNumber') {
      setContactNumber(value);
    } else if (field === 'otp') {
      setOtp(value);
    }

  };
  const handleSendOtpClick = async () => {
    try {
      // Ensure the contact number starts with +91
      const formattedContactNumber = contactNumber.startsWith('+91') ? contactNumber : `+91${contactNumber}`;

      // Send the mobile number to the API with the required body format
      const response = await axios.post(process.env.REACT_APP_API_URL_OTP_SEND, {
        data: {
          phone_number: formattedContactNumber,
          has_firebase_check: false,
        },
      });

      if (response.data.success) {
        setShowOtpInput(true);
        setIsOtpVerified(false);
        setOtp('');
        await fetchUserDetails(contactNumber);
      } else {
        // Handle API errors
        Swal.fire({
          icon: 'error',
          title: 'Failed to Send OTP',
          text: response.data.message || 'Something went wrong. Please try again.',
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to send OTP. Please try again.',
      });
    }
  };
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [plans, setPlans] = useState([]);
  function formatDate(date) {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    const formattedDate = new Date(date).toLocaleDateString('en-US', options);
    return formattedDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$02-$01-$03');
  }
  const calculateDaysDifference = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const timeDifference = end - start;
    const daysDifference = timeDifference / (1000 * 3600 * 24);
    return Math.abs(Math.floor(daysDifference));
  };

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        setLoading(true);
        const response = await fetch(process.env.REACT_APP_API_URL_PURCHASE, {
          headers: {
            "x-api-key": apiKey,
          }
        });

        const data = await response.json();


        const batches = data.batches;

        // Group batches by plan_id
        const batchesByPlan = batches.reduce((acc, batch) => {
          if (!acc[batch.plan_id]) {
            acc[batch.plan_id] = [];
          }
          acc[batch.plan_id].push({
            batchId: batch.id,
            batchName: batch.batch_name,
            batchType: batch.batch_type,
            startDate: batch.start_date,
            endDate: batch.end_date,
            timeSlotStart: batch.time_slot_start,
            timeSlotEnd: batch.time_slot_end,
          });
          return acc;
        }, {});



        const formattedPlans = data.plans.map(plan => {
          const currentDate = '05-04-2025';
          const planStartDate = new Date(plan.start_date);
          const planEndDate = new Date(plan.end_date);

          if (isNaN(planStartDate.getTime()) || isNaN(planEndDate.getTime())) {
            return null; // Skip invalid plans
          }

          const joiningDate = currentDate > planStartDate
            ? formatDateToYYYYMMDD(currentDate)
            : formatDateToYYYYMMDD(plan.start_date);


          setStartDate(joiningDate);
          const lastDate = new Date(joiningDate);
          lastDate.setDate(lastDate.getDate() + 20);
          setEndDate(formatDateToYYYYMMDD(lastDate));
          const daysRemaining = calculateDaysDifference(joiningDate, lastDate);

          return {
            id: plan.id,
            sportId: plan.sport_id,
            name: plan.name || "Unknown Plan",
            price: parseFloat(plan.price).toFixed(0),
            originalPrice: parseFloat(plan.strike_through_price).toFixed(0),
            duration: `${plan.name} (${plan.sessions} sessions)`,
            sessionCount: plan.sessions || 0,
            centerId: plan.academy_id || null,
            planStartDate: formatDateToYYYYMMDD(plan.start_date),
            planEndDate: formatDateToYYYYMMDD(plan.end_date),
            validity: `${daysRemaining} days`,
            batches: batchesByPlan[plan.id] || [], // Attach all batches for this plan
          };
        });

        setPlans(formattedPlans);
        setFilteredPlans(formattedPlans); // Initially set filtered plans to all plans
      } catch (error) {
        setError("Failed to fetch plans.");
      } finally {
        setLoading(false);
      }
    };

    fetchPlans();
  }, []);


  const [filteredPlans, setFilteredPlans] = useState(plans);
  useEffect(() => {
    if (selectedCenter) {
      const selectedCenterData = centers.find(center => center.name === selectedCenter);
      if (selectedCenterData) {
        const availablePlans = plans.filter(plan => plan.centerId === selectedCenterData.id && plan.sportId === 11);
        setFilteredPlans(availablePlans);
      }
    }
  }, [selectedCenter]);

  const handlePlanSelect = (planId) => {
    const selected = filteredPlans.find((plan) => plan.id === planId);
    setSelectedPlan(selected);
    setErrorMessages((prevErrors) => ({ ...prevErrors, selectedPlan: '' }));

    // Dynamically set the current date in YYYY-MM-DD format
    const currentDate = new Date();
    const formattedCurrentDate = currentDate.toISOString().split('T')[0];

    const planStartDate = new Date(selected.planStartDate);
    const planEndDate = new Date(selected.planEndDate);

    if (isNaN(planStartDate.getTime()) || isNaN(planEndDate.getTime())) {
      return;
    }

    const joiningDate = currentDate > planStartDate
      ? formatDateToYYYYMMDD(formattedCurrentDate)
      : formatDateToYYYYMMDD(selected.planStartDate);

    setStartDate(joiningDate);
    setEndDate(formatDateToYYYYMMDD(new Date(new Date(joiningDate).setDate(new Date(joiningDate).getDate() + 19))));


    setSelectedTrialTime(null);
    setSelectedStartTime(null);
    setSelectedEndTime(null);
    setSelectedBatchId(null);

    if (selected && selected.batches) {
      const trialTimes = selected.batches.map(batch => ({
        startTime: batch.timeSlotStart,
        endTime: batch.timeSlotEnd,
        batch_type: batch.batchType,
        batchId: batch.batchId,
      }));
      setTrialTimes(trialTimes);
    } else {
      setTrialTimes([]);
    }
  };
  const convertTo12HourFormat = (time) => {
    if (!time) return "";
    const [hours, minutes] = time.split(":");
    let hour = parseInt(hours, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12; // Convert 24-hour time to 12-hour format
    return `${hour}:${minutes} ${ampm}`;
  };

  const formatDateplan = (dateString) => {
    if (!dateString) return "N/A"; // Handle empty/null values

    const date = new Date(dateString); // Convert string to Date object
    if (isNaN(date)) return "Invalid Date"; // Handle invalid dates

    return date.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  };
  const handleTrialTimeChange = (time, batchId) => {
    setSelectedTrialTime(time);
    setSelectedBatchId(batchId);
    setErrorMessages((prevErrors) => ({ ...prevErrors, selectedTrialTime: '' }));

    const [startTime, endTime] = time.split(' - ');
    setSelectedStartTime(startTime);
    setSelectedEndTime(endTime);
  };

  const availablePlans = selectedCenter
    ? filteredPlans
    : plans;
  const filteredCenters = selectedArea ? areas.find(area => area.name === selectedArea)?.centers || [] : [];

  const sortedCenters = filteredCenters.map(center => {
    const centerData = centers.find(c => c.id === center.id);
    return centerData ? { ...centerData, km: center.km } : null;
  }).filter(center => center !== null).sort((a, b) => a.km - b.km);


  const isContactNumberValid = /^[0-9]{10}$/.test(contactNumber);

  const ConfirmationModal = ({ showModal, onClose, onConfirm, bookingData, updatedAmount }) => {

    if (!showModal) return null;

    const handleConfirm = async () => {
      try {

        const formattedMobileNumber = bookingData.contactNumber.startsWith('+91') ? bookingData.contactNumber : '+91' + bookingData.contactNumber;

        const bookingDataForPurchase = {
          user_id: selectedChildId,
          parent_id: parentId,
          name: bookingData.userName,
          plan_id: bookingData.selectedPlan.id,
          mobile_number: formattedMobileNumber,
          academy_id: bookingData.selectedPlan.centerId,
          sport_id: 11,
          joining_date: startDate,
          expiry_date: endDate,
          start_time: bookingData.start_time,
          end_time: bookingData.end_time,
          batch_id: bookingData.batch_id,
          amount: updatedAmount,
          isUpdate: 0,
          id: null,
          age: bookingData.age,
        };


        const createOrder = await axios.post(
          process.env.REACT_APP_API_URL_PURCHASE,
          bookingDataForPurchase,
          {
            headers: {
              "x-api-key": apiKey,
            },
          }
        );


        bookingDataForPurchase.id = createOrder.data.id;

        if (createOrder.data.user_id) {
          bookingDataForPurchase.user_id = createOrder.data.user_id;  // Ensure user_id is updated
          // setUserId(createOrder.data.user_id);

        } else {

        }

        initiateRazorpayPayment(bookingDataForPurchase, createOrder);

      } catch (error) {
        setErrorMessages({ api: 'Failed to process the booking' });
        showBackendError(error);
      }
    };
    const convertTo12HourFormatsummary = (timeRange) => {
      if (!timeRange) return "";

      const [startTime, endTime] = timeRange.split(" - "); // Split start and end time
      return `${formatTime(startTime)} - ${formatTime(endTime)}`;
    };

    const formatTime = (time) => {
      const [hours, minutes] = time.split(":"); // Extract hours and minutes
      let hour = parseInt(hours, 10);
      const ampm = hour >= 12 ? "PM" : "AM";
      hour = hour % 12 || 12; // Convert 24-hour to 12-hour format
      return `${hour}:${minutes} ${ampm}`; // Keep minutes in format
    };

    const formatDate = (dateString) => {
      if (!dateString) return "N/A"; // Handle empty/null values

      const date = new Date(dateString); // Convert string to Date object
      if (isNaN(date)) return "Invalid Date"; // Handle invalid dates

      return date.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      });
    };


    return (
      <div className="confirmation-modal-overlay">
        <div className="modal-content">
          <button className="close-btn" onClick={onClose}>
            <span className="close-icon">&times;</span>
          </button>
          {discountedShow && (
            <div className="discount-message">
              Hurray! You got a discount! 🎉
            </div>
          )}
          <h3 className="modal-title">Confirm Your Enrollment</h3>

          <div className="booking-summary">
            <p><strong>Name:</strong> {bookingData.userName}</p>
            <p><strong>Contact Number:</strong> {bookingData.contactNumber}</p>
            <p><strong>Age:</strong> {bookingData.age}</p>
            <p><strong>Area:</strong> {bookingData.selectedArea}</p>
            <p><strong>Center:</strong> {bookingData.selectedCenter}</p>
            <p><strong>Plan:</strong> {bookingData.selectedPlan?.name}<span> ({bookingData.selectedPlan?.sessionCount} Sessions)</span></p>
            <p>
              <strong>Time Slot:</strong> {convertTo12HourFormatsummary(bookingData.selectedTrialTime)}
            </p>
            <p><strong>Days:</strong> Monday, Tuesday, Thursday, Friday, Saturday</p>
            <p><strong>Validity:</strong> {formatDate(bookingData.startDate)} to {formatDate(bookingData.endDate)}</p>

            <div className='payment-section'>
              {/* Always show the amount */}
              <div className="payment-details">
                <div className="amount-left">
                  <p><strong>Amount:</strong></p>
                </div>
                <div className="amount-right">
                  <p>₹{parseFloat(bookingData.selectedPlan?.price).toFixed(2)}</p>
                </div>
              </div>

              {/* Conditionally render the discount and total amount details */}
              {discountedShow && (
                <>
                  <div className="payment-details">
                    <div className="amount-left">
                      <p><strong>Discount:</strong></p>
                    </div>
                    <div className="amount-right">
                      <p>₹{parseFloat(discountedAmount).toFixed(2)}</p>
                    </div>
                  </div>
                  <hr style={{ margin: '10px 0', border: '1px solid #ccc', width: '100%' }} />
                  <div className="payment-details">
                    <div className="amount-left">
                      <p><strong>Total Amount:</strong></p>
                    </div>
                    <div className="amount-right">
                      <p>₹{parseFloat(updatedAmount).toFixed(2)}</p>
                      <span style={{ fontStyle: 'italic' }}>(GST Inclusive)</span>
                    </div>
                  </div>
                </>
              )}
            </div>

          </div>

          <div className="modal-actions">
            <button
              onClick={() => {
                trackEvent('InitiateCheckout'); // Track event when user clicks the button
                handleConfirm(); // Execute the existing function
              }}
              className="btn-confirm">Proceed to Payment</button>
          </div>
        </div>
      </div>
    );
  };

  const showBackendError = (error) => {
    let errorMessage = 'Something went wrong. Please try again.';

    // Extract error message from backend response
    if (error.response && error.response.data && error.response.data.message) {
      errorMessage = error.response.data.message;
    } else if (error.message) {
      errorMessage = error.message;
    }

    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: errorMessage,
    });
  };
  const [showAgeDropdown, setShowAgeDropdown] = useState(false); // Add this line
  const ageDropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ageDropdownRef.current && !ageDropdownRef.current.contains(event.target)) {
        setShowAgeDropdown(false); // Close the dropdown
      }
    };

    // Add event listener to document
    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <div className="enroll-trial-container">

      <h2 className="enroll-title">
        <span onClick={() => navigate(-1)} className="arrow-form">&lt;</span>
        Enroll Now
      </h2>

      <form className="enroll-form" onSubmit={handleSubmit}>
        <div className="enrollment-banner">
          Secure Your Spot at the Machaxi Swimming Summer Camp 2025
        </div>
        
          <div className="floating-select" ref={selectWrapperRef}>
            <div
              className={`sales-filter-academy ${selectedArea ? 'has-value' : ''}`}
              onClick={() => setShowAreaDropdown(true)} // Only open, don't toggle
            >
              <div className="selected-option">
                {selectedArea || 'Select an Area'}
              </div>
              <div
                className={`custom-dropdown ${showAreaDropdown ? 'open' : ''}`}
                ref={areaDropdownRef}
                onClick={(e) => e.stopPropagation()} // Prevent closing when interacting with search
              >
                {showAreaDropdown && (
                  <input
                    type="text"
                    placeholder="Search area..."
                    className="search-input"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onClick={(e) => e.stopPropagation()} // Ensure input box doesn’t close dropdown
                  />
                )}
                {areas
                  .filter((area) => area.name.toLowerCase().includes(searchQuery.toLowerCase()))
                  .map((area, index) => (
                    <div
                      key={index}
                      className="custom-option"
                      onClick={() => {
                        handleAreaChange(area.name);
                        setShowAreaDropdown(false); // Close dropdown after selection
                      }}
                    >
                      {area.name}
                    </div>
                  ))}
              </div>
            </div>
            {selectedArea && <label htmlFor="selectedArea">Area</label>}
            {errorMessages.selectedArea && <p className="error">{errorMessages.selectedArea}</p>}
          </div>
        

        { selectedArea && (
          <div className="floating-select" ref={selectWrapperRef}>
            <div
              className={`sales-filter-academy ${selectedCenter ? 'has-value' : ''}`}
              onClick={() => setShowCenterDropdown(!showCenterDropdown)}
            >
              <div className="selected-option">
                {selectedCenter || 'Select Centre'}
              </div>
              <div
                className={`custom-dropdown ${showCenterDropdown ? 'open' : ''}`}
                ref={centerDropdownRef}
              >
                {sortedCenters.map((center) => (
                  <div
                    key={center.id}
                    className="custom-option"
                    onClick={() => handleCenterChange(center.name)}
                  >
                    {center.name}
                  </div>
                ))}
              </div>
            </div>
            {selectedCenter && <label htmlFor="selectedCenter">Centre</label>}
            {errorMessages.selectedCenter && <p className="error">{errorMessages.selectedCenter}</p>}
          </div>
        )}

        { selectedCenter && (
          <div className="enrol-plan-container">
            {filteredPlans.map((plan, index) => (
              <div
                key={index}
                className={`enrol-plan ${selectedPlan?.id === plan.id ? "enrol-plan-selected" : ""}`}
                onClick={() => handlePlanSelect(plan.id)} // Use updated handler
              >
                <div className="enrol-plan-left">
                  <div className="enrol-plan-name">{plan.name}</div>
                  <div className="enrol-plan-duration">{plan.sessionCount} Sessions</div>
                  <div className="enrol-plan-duration">
                    <strong>Validity:</strong> {formatDateplan(plan.planStartDate)} to {formatDateplan(plan.planEndDate)}
                  </div>
                </div>
                <div className="enrol-plan-divider"></div>
                <div className="enrol-plan-right">
                  <div className="discounted-price-enroll">₹{plan.price}</div>
                  <div className="original-price-enroll">₹{plan.originalPrice}</div>
                </div>
              </div>
            ))}
            {errorMessages.selectedPlan && <p className="error">{errorMessages.selectedPlan}</p>} {/* Display plan error */}
          </div>
        )}

        { selectedPlan && (
          <div className="trial-time-picker">
            <label className="trial-time-label">Time Slot:</label>
            <div className="trial-time-options">
              {selectedPlan.batches.map((batch, index) => (
                <button
                  key={index}
                  type="button"
                  className={`trial-time-option ${selectedTrialTime === `${batch.timeSlotStart} - ${batch.timeSlotEnd}` ? 'selected' : ''}`}
                  onClick={() => handleTrialTimeChange(`${batch.timeSlotStart} - ${batch.timeSlotEnd}`, batch.batchId)}
                   >
                  <div>
                    {convertTo12HourFormat(batch.timeSlotStart)} - {convertTo12HourFormat(batch.timeSlotEnd)}
                  </div>
                  <div className="batch-name">
                    {batch.batchType || 'Unknown Batch'}
                  </div>
                </button>
              ))}

            </div>
            {errorMessages.selectedTrialTime && <p className="error">{errorMessages.selectedTrialTime}</p>}
          </div>
        )}
        <div className="floating-select">
          <input
            className={`sales-filter-academy ${contactNumber ? 'has-value' : ''}`}
            type="tel"
            value={contactNumber}
            onChange={(e) => handleInputChange(e, 'contactNumber')}
            onKeyPress={(e) => {
              if (!/^[0-9]$/.test(e.key)) {
                e.preventDefault();
              }
            }}
            maxLength={10}
            placeholder="Enter 10-digit phone number"
          />

          {contactNumber && <label htmlFor="contactNumber">Contact Number</label>}
          {errorMessages.contactNumber && <p className="error">{errorMessages.contactNumber}</p>}
          {errorMessages.otp && <p className="error">{errorMessages.otp}</p>}
          {isOtpVerified && (
            <span className="checkmark">✓</span>
          )}

          {!showOtpInput && !isOtpVerified && isContactNumberValid && (
            <button type="button" onClick={handleSendOtpClick} className="btn-send-otp">
              Send OTP
            </button>
          )}
        </div>

        {showOtpInput && !isOtpVerified && (
          <div className="floating-select">
            <input
              className={`sales-filter-academy ${otp ? 'has-value' : ''}`}
              type="text"
              value={otp}
              onChange={(e) => handleInputChange(e, 'otp')}
              maxLength={6}
              placeholder="Enter OTP"
            />
            <button type="button" onClick={handleOtpVerification} className="btn-send-otp">
              Verify OTP
            </button>
          </div>
        )}


        {isNewUser && isOtpVerified && (
          <div className="floating-select">
            <input
              className={`sales-filter-academy ${userName ? 'has-value' : ''}`}
              type="text"
              value={userName}
              onChange={(e) => handleInputChange(e, 'userName')}
              placeholder="Enter your name"
            />
            {userName && <label htmlFor="userName">Name</label>}
            {errorMessages.userName && <p className="error">{errorMessages.userName}</p>}
          </div>
        )}

        {isOtpVerified && userDetails && (
          <div className="floating-select-child" ref={selectWrapperRef}>
            <label htmlFor="child" className="selectchild">Select Child</label>
            <div className={`sales-filter-academy ${userName ? 'has-value' : ''}`}>
              {/* Radio Buttons for Existing Children */}
              <div className="custom-options">
                {userDetails.children.map((child, index) => (
                  <div
                    key={index}
                    className={`custom-option ${selectedChildId === child.id ? 'selected' : ''}`}
                    onClick={() => handleChildSelect(child)}
                  >
                    <input
                      type="radio"
                      checked={selectedChildId === child.id}
                      readOnly
                      className="radio-dot"
                    />
                    <span>{child.name}</span>
                  </div>
                ))}
              </div>

              {showCreateChildInput ? (
                <div className="floating-select">
                  <input
                    className={`sales-filter-academy ${newChildName ? 'has-value' : ''}`}
                    type="text"
                    value={newChildName}
                    onChange={(e) => setNewChildName(e.target.value)}
                    placeholder="Enter child's name"
                    onClick={(e) => e.stopPropagation()}
                  />
                  {newChildName && <label htmlFor="newChildName">Child's Name</label>}

                  <button
                    type="button"
                    className="btn-send-otp"
                    onClick={() => {
                      if (newChildName.trim()) {
                        // Check if a child with null ID already exists
                        const existingNewChildIndex = userDetails.children.findIndex(
                          (child) => child.id === null
                        );

                        if (existingNewChildIndex !== -1) {
                          // Update existing child's name
                          const updatedChildren = [...userDetails.children];
                          updatedChildren[existingNewChildIndex].name = newChildName;
                          setUserDetails((prevDetails) => ({
                            ...prevDetails,
                            children: updatedChildren,
                          }));
                        } else {
                          // Create new child
                          const newChild = {
                            id: null,
                            name: newChildName,
                          };
                          setUserDetails((prevDetails) => ({
                            ...prevDetails,
                            children: [...prevDetails.children, newChild],
                          }));
                        }

                        // Clear input & close form
                        setUserName(newChildName);
                        setSelectedChildId(null);
                        setShowCreateChildInput(false);

                        // Show success message
                        Swal.fire({
                          icon: "success",
                          title: "Success",
                          text: `Child "${newChildName}" saved!`,
                          toast: true,
                          position: "top-end",
                          showConfirmButton: false,
                          timer: 1000,
                        });
                      } else {
                        Swal.fire({
                          title: 'Error!',
                          text: 'Please enter a name for the child.',
                          icon: 'error',
                          confirmButtonText: 'OK',
                        });
                      }
                    }}
                  >
                    {userDetails.children.some((child) => child.id === null)
                      ? 'Save Changes'
                      : 'Save Child'}
                  </button>
                </div>
              ) : (
                <div className="create-new-child-container">
                  <button
                    type="button"
                    className="btn-create-child"
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowCreateChildInput(true);
                    }}
                  >
                    {userDetails.children.some((child) => child.id === null)
                      ? 'Edit Child'
                      : 'Add Child'}
                  </button>
                </div>

              )}
            </div>


            {errorMessages.child && <p className="error">{errorMessages.child}</p>}
          </div>
        )}


        {isOtpVerified && (
          <div className="floating-select" ref={selectWrapperRef}>
            {/* Age Range Radio Buttons */}
            <div
              className={`sales-filter-academy ${selectedAge ? 'has-value' : ''}`}
            >

              <div className="radio-group">
                {/* 5 to 8 Age Range */}
                <div
                  className="custom-option"
                  onClick={() => {
                    setSelectedAge('5-8');
                    setErrorMessages((prevErrors) => ({ ...prevErrors, age: '' }));
                  }}
                >
                  <input
                    type="radio"
                    className="radio-dot"
                    checked={selectedAge === '5-8'}
                    onChange={() => { }}
                  />
                  <span>5 to 8</span>
                </div>

                {/* 8 to 10 Age Range */}
                <div
                  className="custom-option"
                  onClick={() => {
                    setSelectedAge('8-10');
                    setErrorMessages((prevErrors) => ({ ...prevErrors, age: '' }));
                  }}
                >
                  <input
                    type="radio"
                    className="radio-dot"
                    checked={selectedAge === '8-10'}
                    onChange={() => { }}
                  />
                  <span>8 to 10</span>
                </div>

                {/* 10 to 12 Age Range */}
                <div
                  className="custom-option"
                  onClick={() => {
                    setSelectedAge('10-12');
                    setErrorMessages((prevErrors) => ({ ...prevErrors, age: '' }));
                  }}
                >
                  <input
                    type="radio"
                    className="radio-dot"
                    checked={selectedAge === '10-12'}
                    onChange={() => { }}
                  />
                  <span>10 to 12</span>
                </div>

                {/* 12 to 16 Age Range */}
                <div
                  className="custom-option"
                  onClick={() => {
                    setSelectedAge('12-16');
                    setErrorMessages((prevErrors) => ({ ...prevErrors, age: '' }));
                  }}
                >
                  <input
                    type="radio"
                    className="radio-dot"
                    checked={selectedAge === '12-16'}
                    onChange={() => { }}
                  />
                  <span>12 to 16</span>
                </div>
              </div>
            </div>

            {selectedAge && <label htmlFor="age">Age Range</label>}
            {errorMessages.age && <p className="error">{errorMessages.age}</p>}
          </div>
        )}


        <div className="form-group">
          <button className="form-button" type="submit">Submit</button>

        </div>

        <ConfirmationModal
          showModal={showConfirmationModal}
          onClose={() => setShowConfirmationModal(false)}
          onConfirm={() => {
            alert('Booking Confirmed!');
            setShowConfirmationModal(false);
          }}
          bookingData={formData}
          updatedAmount={updatedAmount}
        />
      </form>
    </div>
  );
};

export default BookTrial;